import axios from "axios";

const CACHE_KEY = "lakato_system_notices_cache_v1";
const CACHE_TTL_MS = 10 * 1000;

function readCache() {
    try {
        const raw = window.sessionStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.ts || !parsed.data) return null;
        if (Date.now() - parsed.ts > CACHE_TTL_MS) return null;
        return parsed.data;
    } catch (e) {
        return null;
    }
}

function writeCache(data) {
    try {
        window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data }));
    } catch (e) {
        // ignore
    }
}

export function clearSystemNoticesCache() {
    try {
        window.sessionStorage.removeItem(CACHE_KEY);
    } catch (e) {
        // ignore
    }
}

export async function getActiveSystemNotices(opts = {}) {
    const force = !!opts.force;

    if (!force) {
        const cached = readCache();
        if (cached) return cached;
    }

    const res = await axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}system-notices/active`,
    });

    writeCache(res.data);
    return res.data;
}

